import type { Response } from '@/apis/common.types';
import type { ServiceFloorData } from '@/components/product/interface';
import { jdiColorFetch } from '../colorFetchV2';
import { CartData, GetCartRequest, GetFloorRequest, TypeDetailInfo } from './cart.interface';

/*
 * https://joyspace.jd.com/pages/BtxZlGfcF01xyoDFMsEJ
 * @interface Data
 */

// 查询购物车详情的 API 方法
export const fetchCartDetail = (requestData: GetCartRequest): Promise<CartData> => {
  return jdiColorFetch(`trade_cart_get`, {
    method: 'get',
    bodyQuery: { ...requestData },
  })
    .then((response: any) => response?.data)
    .catch((error: any) => error);
};

// 全选/单选/数量加减
export const selectAll = (requestData: GetCartRequest): Promise<CartData> => {
  return jdiColorFetch(`trade_cart_modifyItem`, {
    method: 'post',
    bodyQuery: { ...requestData },
  })
    .then((response: any) => response?.data)
    .catch((error: any) => error);
};

// 选择其他商品类型 API 方法
export const selectOtherProType = (requestData: GetCartRequest): Promise<TypeDetailInfo> => {
  return jdiColorFetch(`trade_item_getLite`, {
    method: 'get',
    bodyQuery: { ...requestData },
  })
    .then((response: any) => response?.data)
    .catch((error: any) => error);
};

// 加入购物车 API 方法 未使用
export const addCart = async (requestData: GetCartRequest): Promise<Response<CartData>> => {
  return await jdiColorFetch(`trade_cart_addItem`, {
    method: 'get',
    bodyQuery: { ...requestData },
  });
};

// 拼购推荐列表 https://joyspace.jd.com/pages/weO4RiBTmBfh9Uix1Q11
export const recommendList = (requestData: any): Promise<any> => {
  return jdiColorFetch(`guide_recommendation_get`, {
    method: 'post',
    bodyQuery: { ...requestData },
  })
    .then((response: any) => response?.data)
    .catch((error: any) => error);
};

// 获取服务品楼层数据 https://joyspace.jd.com/pages/WUiyilBvEVt97c9zjdBl 4.7
export const getServiceFloor = (requestData: GetFloorRequest): Promise<any> => {
  return jdiColorFetch(`trade_item_getFloor`, {
    method: 'get',
    bodyQuery: {
      ...requestData,
      verticalTag: 'cn_ybxt_b2c',
    },
  })
    .then((response: Response<ServiceFloorData>) => response?.data)
    .catch((error: any) => error);
};
